import { render, staticRenderFns } from "./DashboardViewEditingFilters.vue?vue&type=template&id=59c9f896"
import script from "./DashboardViewEditingFilters.vue?vue&type=script&lang=js"
export * from "./DashboardViewEditingFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports